import { get } from 'lodash'

const getErrorCodes = (errorData: any, path: string[]) => {
  // eslint-disable-next-line camelcase
  const errorDetails = get(errorData, path)

  if (errorDetails && Array.isArray(errorDetails)) {
    const errorCodes = errorDetails.map((error: any) => error.error)

    return errorCodes
  }

  if (errorDetails && typeof errorDetails === 'object') {
    const errorDetailsKeys = Object.keys(errorDetails)
    const errorCodes = errorDetailsKeys.map((error: any) => error.error)

    return errorCodes
  }

  return []
}

export default getErrorCodes
